import { useApi } from '.';
import { useInstallationContext } from '../../../../context/installation';

export const useLoading = () => {
  const { channelsLoading, devicesLoading, dashboardLoading } = useApi();
  const { selectedInstallationId, currentInstallationLoading, skipLavvaFetch } = useInstallationContext();

  const channels =
    !currentInstallationLoading && !selectedInstallationId ? channelsLoading : !!(channelsLoading || skipLavvaFetch);
  const devices =
    !currentInstallationLoading && !selectedInstallationId ? devicesLoading : !!(devicesLoading || skipLavvaFetch);
  const dashboard =
    !currentInstallationLoading && !selectedInstallationId ? dashboardLoading : !!(dashboardLoading || skipLavvaFetch);

  return {
    loadingChannels: channels,
    loadingDevices: devices,
    loadingDashboard: dashboard,
  };
};
